import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { Trade } from 'ah-api-gateways/models';
import TradeStateBadge from 'ah-common-lib/src/common/components/trade/TradeStateBadge.vue';
import TradeMarginInfo from './TradeMarginInfo.vue';
import TradeProfitInfo from './TradeProfitInfo.vue';
import TradeDrawdownInfo from './TradeDrawdownInfo.vue';
import TradeInfo from './TradeInfo.vue';
import { computed, reactive, ref } from 'vue';
import { useAhTradesState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { AdminTrade } from 'ah-api-gateways/models/trade';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeDetailsModal',
  props: {
    tradeId: null,
    title: { default: 'Trade Details' },
    showAmended: { type: [Boolean, String], default: false },
    childrenId: null,
    hideState: { type: [Boolean, String], default: false }
  },
  setup(__props: any) {

const props = __props as { tradeId: string, title: string, showAmended: boolean | string, childrenId?: string, hideState: boolean | string };

const tradeState = useAhTradesState();



const tradeDetailsModal = ref<InstanceType<typeof BModal> | null>(null);

const requestManager = useRequestManager();

const state = reactive({
  trade: null as Trade | null,
  childTrade: null as Trade | null,
});

const isAHUser = computed(() => {
  return tradeState.store.useAuthStore().isAHUser;
});

const adminTrade = computed(() => {
  if (isAHUser.value && (state.trade as AdminTrade).gbpAhProfit) {
    return state.trade as AdminTrade;
  }
  return null;
});

const anyPending = computed(() => {
  return requestManager.manager.anyPending;
});

const parentTradeReference = computed(() => {
  return state.trade?.referenceNumber ?? null;
});

const shouldHideState = computed(() => {
  return props.hideState !== true;
});

const tradeRequestKey = computed(() => {
  return `getTrade-${props.tradeId}`;
});

const drawdownRequestKey = computed(() => {
  return `getDrawdown-${props.tradeId}`;
});

function show() {
  tradeDetailsModal.value!.show();
}

function hide() {
  requestManager.manager.cancel(tradeRequestKey.value);
  tradeDetailsModal.value!.hide();
}

function loadTrade() {
  if (props.showAmended !== false) {
    // Currently we only allow amending a trade once, thus always getting the first element of
    // the filtered list
    requestManager.manager
      .sameOrCancelAndNew(
        tradeRequestKey.value,
        tradeState.services.trade.listTrades({ amendedTradeId: props.tradeId })
      )
      .subscribe(
        (response) => {
          if (response.list.length > 0) {
            state.trade = response.list[0];
          } else {
            tradeState.toast.error('No amended trades here found.');
            hide();
          }
        },
        () => hide()
      );
  } else {
    requestManager.manager
      .sameOrCancelAndNew(tradeRequestKey.value, tradeState.services.trade.getTrade(props.tradeId))
      .subscribe(
        (response) => (state.trade = response),
        () => hide()
      );
  }

  if (props.childrenId) {
    requestManager.manager
      .sameOrCancelAndNew(drawdownRequestKey.value, tradeState.services.trade.getTrade(props.childrenId))
      .subscribe((response) => (state.childTrade = response));
  }
}

loadTrade();

return { __sfc: true,tradeState, props, tradeDetailsModal, requestManager, state, isAHUser, adminTrade, anyPending, parentTradeReference, shouldHideState, tradeRequestKey, drawdownRequestKey, show, hide, loadTrade, BModal, TradeStateBadge, TradeMarginInfo, TradeProfitInfo, TradeDrawdownInfo, TradeInfo }
}

})